import React, { useEffect, useState } from "react";
import axios from "axios";
import AppContext from "./app-context";

const url = process.env.REACT_APP_URL;

function AppState(props) {
  const [auth, setAuth] = useState(false);
  const [callTime, setcallTime] = useState("");
  const [orgStartDate, setOrgStartDate] = useState("");
  const [ts, setTs] = useState("");
  const [orgEndDate, setOrgEndDate] = useState("");
  const [emergency, setEmergency] = useState(false);
  const [dateArray, setDateArray] = useState([]);
  const [nc, setNc] = useState([]);
  const [data, setData] = React.useState([])
  const [busStop, setBusStop] = React.useState([]);
  const [road, setRoad] = React.useState([]);
  const [wc, setWc] = React.useState([]);
  const [siteCode, setSiteCode] = useState([])
  const [sites, setSites] = useState("")
  const [addressData, setAddressData] = useState([]);
  const [sitess, setSitess] = useState("")
  const [coordinates, setCoordinates] = useState("");
  const [towards, setTowards] = React.useState([]);
  const [addresses, setAddresses] = React.useState([])
  const [numberOfEmergency, setNumberOfEmergency] = useState(0)
  const [numberOfFunctional, setNumberOfFunctional] = useState(0)
  const [numberOfNonFunctional, setNumberOfNonFunctional] = useState(0)
  const [progressValue, setProgressValue] = useState(0)
  const [age, setAge] = React.useState('');

  useEffect(() => {
    let cancelled = false;

    const syncDashboard = async () => {
      try {
        const [masterResponse, buttonResponse] = await Promise.all([
          axios.get(`${url}/api/v1/get/master`),
          axios.get(`${url}/api/v1/button_pressed`),
        ]);
        const rows = Array.isArray(masterResponse.data?.data) ? masterResponse.data.data : [];
        const buttonRows = Array.isArray(buttonResponse.data?.data) ? buttonResponse.data.data : [];
        if (cancelled) {
          return;
        }

        const latestButtonPress = buttonRows[0];
        const latestButtonPressTime = latestButtonPress
          ? new Date(String(latestButtonPress.ts || latestButtonPress.timestamp || latestButtonPress.received_at || "")).getTime()
          : 0;
        const recentButtonPress = latestButtonPressTime
          ? Date.now() - latestButtonPressTime <= 5 * 60 * 1000
          : false;

        setAddressData(rows);
        setNumberOfEmergency(
          rows.filter((item) => item.emergency === "yes").length + (recentButtonPress ? 1 : 0)
        );
        setNumberOfFunctional(rows.filter((item) => item.functional === "yes").length);
        setNumberOfNonFunctional(rows.filter((item) => item.non_functional === "yes").length);
        setEmergency(rows.some((item) => item.emergency === "yes") || recentButtonPress);

        const latest = rows
          .slice()
          .sort((a, b) => new Date(String(b.last_call_time || b.last_health_data_time || b.ts || 0)).getTime() - new Date(String(a.last_call_time || a.last_health_data_time || a.ts || 0)).getTime())[0];

        if (latest) {
          setTs(String(latest.last_call_time || latest.last_health_data_time || latest.ts || ""));
        }
      } catch (error) {
        console.log("dashboard sync failed", error);
      }
    };

    syncDashboard();
    const intervalId = setInterval(syncDashboard, 500);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, []);

  return (
    <AppContext.Provider
      value={{
        auth,
        setAuth,
        callTime,
        setcallTime,
        orgStartDate,
        orgEndDate,
        setOrgStartDate,
        setOrgEndDate,
        addresses, setAddresses,
        ts,
        age, setAge,
        setTs,
        emergency,
        setEmergency,
        dateArray, setDateArray, nc, setNc,data, setData, busStop, setBusStop,road, setRoad,siteCode,sites, setSites, setSiteCode,
        addressData, setAddressData,sitess, setSitess,coordinates, setCoordinates,towards, setTowards,
        numberOfEmergency, setNumberOfEmergency, numberOfFunctional, setNumberOfFunctional, numberOfNonFunctional, setNumberOfNonFunctional,
        message: "This is from the context", progressValue, setProgressValue
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
}

export default AppState;
